/**
 *
 * Removes trailing zeros in version string.
 * eg., '1.0.0' -> '1', '2.2.0' -> '2.2', '0.0.0' -> '0'
 *
 * @param version
 */
var normalize = function (version) {
    var parts = version.split('.');
    var i = parts.length - 1;
    while (i > 0) {
        if (parts[i] === '0') {
            i--;
        }
        else {
            break;
        }
    }
    return parts.slice(0, i + 1).join('.');
};
/**
 *  1. version a > b => -1
 *  2. version a < b => 1
 *  3. version a == b => 0
 */
export var versionComparator = function (a, b) {
    var aParts = normalize(a).split('.');
    var bParts = normalize(b).split('.');
    var len = Math.min(aParts.length, bParts.length);
    for (var i = 0; i < len; i++) {
        var aPart = parseInt(aParts[i], 10);
        var bPart = parseInt(bParts[i], 10);
        if (aPart > bPart) {
            return -1;
        }
        else if (aPart < bPart) {
            return 1;
        }
    }
    return aParts.length > bParts.length
        ? -1
        : aParts.length < bParts.length
            ? 1
            : 0;
};
/**
 * v1 > v2
 */
export function gt(v1, v2) {
    return versionComparator(v1, v2) === -1;
}
/**
 * v1 >= v2
 */
export function gte(v1, v2) {
    var diff = versionComparator(v1, v2);
    return diff === -1 || diff === 0;
}
/**
 * v1 < v2
 */
export function lt(v1, v2) {
    return versionComparator(v1, v2) === 1;
}
/**
 * v1 <= v2
 */
export function lte(v1, v2) {
    var diff = versionComparator(v1, v2);
    return diff === 1 || diff === 0;
}
export function getLaterVersions(versions, currentVersion) {
    var laterVersions = [];
    if (versions.includes(currentVersion)) {
        laterVersions = versions.slice().sort(versionComparator); // decresing order
    }
    else {
        laterVersions = versions.concat(currentVersion).sort(versionComparator); // decresing order
    }
    var currentVersionIndex = laterVersions.findIndex(function (v) { return v === currentVersion; });
    if (currentVersionIndex >= 0) {
        laterVersions = laterVersions.slice(0, currentVersionIndex);
    }
    return laterVersions;
}
export var majorVersion = function (version) { return +version.split('.')[0]; };
export var getPSPack = function (version) {
    return version
        .split('.')
        .slice(-1)
        .join('');
};
export var getVersionWithoutPolicy = function (version) {
    return version
        .split('.')
        .slice(0, 3)
        .join('.');
};
